import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useFileDownload } from '@/hooks/useFileDownload';
import { RenderType } from './RenderType';
export const Attachments = ({ id, filename, title, url, type }) => {
    const { handleFileDownload } = useFileDownload();
    const [isDownloading, setIsDownloading] = useState(() => !url && type === 'image');
    useEffect(() => {
        if (!url) {
            handleFileDownload(id, filename, title);
        }
    }, [filename, handleFileDownload, id, url, title]);
    const handleImageLoad = useCallback(() => {
        setIsDownloading(false);
    }, []);
    return (_jsx(RenderType, { type: type, url: url, title: title, isDownloading: isDownloading, handleImageLoad: handleImageLoad }));
};
